// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-app .alert-grid .alert-card {
  background-color: #282b30;
width: 90%;
height: 90%;
  padding: 10px;
  text-align: left;
  border-radius: 0 !important;
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
  color: #666666 !important;
  background: #919191 !important;
  border: 1px solid #999999 !important;

}
.alert-search {
  width: 100%;
  height: 100%;
}
.alert-search input {
  margin-bottom: 0px;
  width: 99%;
  background-color: #07070e;
  border: 2px solid #282b30;
}


.alert-row {
  display: flex;
  background-color: #282b30;
  align-items: center;
  border: 1px solid #6f7071;
  color: #FFF;
  /* min-height: 65.75px;
  max-height: 65.75px; */
}

.alert-app .alert-grid .MuiGrid-item {
  display: flex;
  text-align: center;
  justify-content: center;
  /* height: fit-content; */
  /* min-width: 300px;
  min-height: 150px; */
}
.alert-app .MuiGrid-item {
  text-align: center;
  justify-content: center;
  width: 100%;
}

.alertCardIcon {
  display: inline-block;
  padding: 10px;
  margin-top: 0;
}
.alertCardContent {
  display: inline-block;
  color: #707070;
}
.alertCardContent h4 {
  margin: 0;
  color: #bbbcbd !important;
}
.alert-app .alert-grid .alert-card .alertCardIcon .css-i4bv87-MuiSvgIcon-root {
  width: 1.6em !important;
  height: 1.6em !important;
}

.alert-app .alert-grid .alert-card .alertCardIcon .css-i8h7p9-MuiSvgIcon-root {
  width: 1.6em !important;
  height: 1.6em !important;
  fill: #9f63ec !important;
}

.alert-app
  .alert-grid
  .alert-card
  .alertCardIcon
  [data-testid="CheckCircleIcon"] {
  fill: #4996ee !important;
}

.alert-app .alert-grid .alert-card .alertCardIcon [data-testid="CancelIcon"] {
  fill: #e16162 !important;
}

.container {
  max-height: 53vh;
}

.box {
  border: 2px solid rgb(97, 88, 88);
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  min-width: 340px;
  min-height: 190px;
}

.dragger {
  align-self: self-end;
  cursor: pointer;
  border: 2px solid rgb(97, 88, 88);
  font-size: 1rem;
  float: right;
  position: relative;
  bottom: -20px;
  right: -20px;
  margin-left: auto;
}

.resizebleContainer{
    max-height: inherit;
    min-width: 100%;
    max-width: 100%;
    overflow: hidden;
}
.resizebleContainer > div{
    max-height: inherit;
    min-width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    height: -webkit-fill-available;
    height: -moz-available;
    height: 100%;
}

.blinking-red {
  color: #E16162 !important;
  animation: blinking 1s infinite;
}

@keyframes blinking {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.aiBorder{
  border: 3px inset #6d6d6d !important;
}

.redAlert {
  color: #E16162;
}

.orangeAlert {
  color: rgb(212, 146, 23);
}

.yellowAlert {
  color: rgb(204, 218, 22);
  background-color: none !important;
}

.alert-card {
  border-width: 2px;
  border-style: solid;
  border-radius: 4px;
}

.redAlert {
  color: #E16162;
}

.orangeAlert {
  color: rgb(253, 172, 20);
}

.yellowAlert {
  color: rgb(241, 241, 34);
}
.greenAlert {
  color: green;
}
.aiAlert{
  color: #9f63ec;
  animation: blinkk 5s infinite;
}
@keyframes blinkk {
  0% {
    opacity: 0.1;
  }
  80% {
    opacity: 1;
  }
 
}

.red {
  border-color: #282B30;
}

.orange {
  border-color: #282B30;
}

.yellow {
  border-color: #282B30;
}
.green {
  color: #282B30;
}

.alert-app .css-1hdyuqk-MuiPaper-root-MuiAlert-root{
  background-color: #282b30 !important;
  padding: 0 !important;
}

.alert-app .css-1pxa9xg-MuiAlert-message h2{

  margin: 0 !important;
}

.alert-app .css-i4bv87-MuiSvgIcon-root{
  margin-bottom: -4px;
}

.alert-app .css-1hdyuqk-MuiPaper-root-MuiAlert-root .MuiAlert-icon{
  display: none;
}

.alert-app .alert-grid{
    overflow-y: scroll;
    padding-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/Testing/testing.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B,UAAU;AACV,WAAW;EACT,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;;AAEtC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX;wBACsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB;sBACoB;AACtB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,SAAS;EACT,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;;AAEF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".alert-app .alert-grid .alert-card {\n  background-color: #282b30;\nwidth: 90%;\nheight: 90%;\n  padding: 10px;\n  text-align: left;\n  border-radius: 0 !important;\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n  color: #666666 !important;\n  background: #919191 !important;\n  border: 1px solid #999999 !important;\n\n}\n.alert-search {\n  width: 100%;\n  height: 100%;\n}\n.alert-search input {\n  margin-bottom: 0px;\n  width: 99%;\n  background-color: #07070e;\n  border: 2px solid #282b30;\n}\n\n\n.alert-row {\n  display: flex;\n  background-color: #282b30;\n  align-items: center;\n  border: 1px solid #6f7071;\n  color: #FFF;\n  /* min-height: 65.75px;\n  max-height: 65.75px; */\n}\n\n.alert-app .alert-grid .MuiGrid-item {\n  display: flex;\n  text-align: center;\n  justify-content: center;\n  /* height: fit-content; */\n  /* min-width: 300px;\n  min-height: 150px; */\n}\n.alert-app .MuiGrid-item {\n  text-align: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.alertCardIcon {\n  display: inline-block;\n  padding: 10px;\n  margin-top: 0;\n}\n.alertCardContent {\n  display: inline-block;\n  color: #707070;\n}\n.alertCardContent h4 {\n  margin: 0;\n  color: #bbbcbd !important;\n}\n.alert-app .alert-grid .alert-card .alertCardIcon .css-i4bv87-MuiSvgIcon-root {\n  width: 1.6em !important;\n  height: 1.6em !important;\n}\n\n.alert-app .alert-grid .alert-card .alertCardIcon .css-i8h7p9-MuiSvgIcon-root {\n  width: 1.6em !important;\n  height: 1.6em !important;\n  fill: #9f63ec !important;\n}\n\n.alert-app\n  .alert-grid\n  .alert-card\n  .alertCardIcon\n  [data-testid=\"CheckCircleIcon\"] {\n  fill: #4996ee !important;\n}\n\n.alert-app .alert-grid .alert-card .alertCardIcon [data-testid=\"CancelIcon\"] {\n  fill: #e16162 !important;\n}\n\n.container {\n  max-height: 53vh;\n}\n\n.box {\n  border: 2px solid rgb(97, 88, 88);\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px;\n  min-width: 340px;\n  min-height: 190px;\n}\n\n.dragger {\n  align-self: self-end;\n  cursor: pointer;\n  border: 2px solid rgb(97, 88, 88);\n  font-size: 1rem;\n  float: right;\n  position: relative;\n  bottom: -20px;\n  right: -20px;\n  margin-left: auto;\n}\n\n.resizebleContainer{\n    max-height: inherit;\n    min-width: 100%;\n    max-width: 100%;\n    overflow: hidden;\n}\n.resizebleContainer > div{\n    max-height: inherit;\n    min-width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n    height: -webkit-fill-available;\n    height: -moz-available;\n    height: 100%;\n}\n\n.blinking-red {\n  color: #E16162 !important;\n  animation: blinking 1s infinite;\n}\n\n@keyframes blinking {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n.aiBorder{\n  border: 3px inset #6d6d6d !important;\n}\n\n.redAlert {\n  color: #E16162;\n}\n\n.orangeAlert {\n  color: rgb(212, 146, 23);\n}\n\n.yellowAlert {\n  color: rgb(204, 218, 22);\n  background-color: none !important;\n}\n\n.alert-card {\n  border-width: 2px;\n  border-style: solid;\n  border-radius: 4px;\n}\n\n.redAlert {\n  color: #E16162;\n}\n\n.orangeAlert {\n  color: rgb(253, 172, 20);\n}\n\n.yellowAlert {\n  color: rgb(241, 241, 34);\n}\n.greenAlert {\n  color: green;\n}\n.aiAlert{\n  color: #9f63ec;\n  animation: blinkk 5s infinite;\n}\n@keyframes blinkk {\n  0% {\n    opacity: 0.1;\n  }\n  80% {\n    opacity: 1;\n  }\n \n}\n\n.red {\n  border-color: #282B30;\n}\n\n.orange {\n  border-color: #282B30;\n}\n\n.yellow {\n  border-color: #282B30;\n}\n.green {\n  color: #282B30;\n}\n\n.alert-app .css-1hdyuqk-MuiPaper-root-MuiAlert-root{\n  background-color: #282b30 !important;\n  padding: 0 !important;\n}\n\n.alert-app .css-1pxa9xg-MuiAlert-message h2{\n\n  margin: 0 !important;\n}\n\n.alert-app .css-i4bv87-MuiSvgIcon-root{\n  margin-bottom: -4px;\n}\n\n.alert-app .css-1hdyuqk-MuiPaper-root-MuiAlert-root .MuiAlert-icon{\n  display: none;\n}\n\n.alert-app .alert-grid{\n    overflow-y: scroll;\n    padding-top: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
